// FacebookAccount + FacebookPageFeed i18n fragment
// Namespaces: fbAcc.* (FacebookAccount views), fbFeed.* (FacebookPageFeed views).
// vi = verbatim Vietnamese, en = natural concise English. Keys must stay in parity.
const fragment = {
  vi: {
    // FacebookAccount — FacebookAcount.js
    'fbAcc.facebookAccount.title': 'Tài khoản Facebook',
    'fbAcc.facebookAccount.add': 'Thêm',
    'fbAcc.facebookAccount.searchLabel': 'Tìm kiếm tài khoản',
    'fbAcc.facebookAccount.search': 'Tìm kiếm',
    'fbAcc.facebookAccount.reset': 'Đặt lại',

    // FacebookAccount — PageList.js
    'fbAcc.pageList.title': 'Danh sách Page',
    'fbAcc.pageList.titleManagedBy': 'Page do {name} quản trị',
    'fbAcc.pageList.backToAccounts': 'Quay lại tài khoản',
    'fbAcc.pageList.subtitle': 'Chọn một Page để xem danh sách bài viết Page đó đã đăng.',
    'fbAcc.pageList.loading': 'Đang tải danh sách Page…',
    'fbAcc.pageList.loadFailed': 'Không tải được danh sách Page',
    'fbAcc.pageList.loadFailedHint': 'Token có thể đã hết hạn. Hãy đăng nhập lại Facebook.',
    'fbAcc.pageList.emptyTitle': 'Không có Page nào',
    'fbAcc.pageList.emptyDesc': 'Tài khoản này hiện không là admin của Page nào.',
    'fbAcc.pageList.total': 'Tổng cộng {count} Page',
    'fbAcc.pageList.viewPosts': 'Xem bài viết',
    'fbAcc.pageList.resync': 'Đồng bộ lại',
    'fbAcc.pageList.resyncing': 'Đang đồng bộ…',
    'fbAcc.pageList.resyncSuccess': 'Đã đồng bộ danh sách Page',
    'fbAcc.pageList.resyncFailed': 'Đồng bộ thất bại',
    'fbAcc.pageList.syncedAt': 'Đồng bộ lúc {time}',
    'fbAcc.pageList.neverSynced': 'Chưa đồng bộ',

    // FacebookAccount — components/Table.js
    'fbAcc.table.colName': 'Tên tài khoản',
    'fbAcc.table.colLink': 'Liên kết',
    'fbAcc.table.colStatus': 'Trạng thái',
    'fbAcc.table.colCreatedAt': 'Ngày tạo',
    'fbAcc.table.colAction': 'Thao tác',
    'fbAcc.table.viewProfile': 'Xem trang',
    'fbAcc.table.viewPages': 'Xem danh sách Page',
    'fbAcc.table.updateAccount': 'Cập nhật tài khoản',
    'fbAcc.table.refreshScope': 'Cấp lại quyền / làm mới scope',
    'fbAcc.table.deleteAccount': 'Xóa tài khoản',
    'fbAcc.table.statusChanged': 'Đã thay đổi trạng thái tài khoản',
    'fbAcc.table.statusChangeFailed': 'Thay đổi trạng thái tài khoản thất bại',
    'fbAcc.table.deleteTitle': 'Xoá tài khoản Facebook?',
    'fbAcc.table.delete': 'Xoá',
    'fbAcc.table.deleteDescDefault': 'Hành động này không thể hoàn tác.',
    'fbAcc.table.deleteDescScheduled':
      'Tài khoản này đang có {count} bài viết đã lên lịch. Khi xoá, các bài này sẽ tạm dừng cho đến khi bạn kết nối lại cùng tài khoản Facebook (cùng user_id) — lịch sẽ tự động tiếp tục. Bạn vẫn muốn xoá?',
    'fbAcc.table.deleteSuccess': 'Xóa tài khoản thành công',
    'fbAcc.table.emptyTitle': 'Chưa có dữ liệu',
    'fbAcc.table.emptyDesc': 'Hãy thêm bản ghi đầu tiên để bắt đầu',

    // FacebookPageFeed — FacebookPageFeed.js
    'fbFeed.facebookPageFeed.title': 'Bài viết của Page',
    'fbFeed.facebookPageFeed.subtitle':
      'Đồng bộ và xem lại toàn bộ bài viết do Page bạn quản trị đã đăng.',
    'fbFeed.facebookPageFeed.accountLabel': 'Tài khoản Facebook',
    'fbFeed.facebookPageFeed.accountPlaceholder': 'Chọn tài khoản',
    'fbFeed.facebookPageFeed.pageLabel': 'Page (bạn là admin)',
    'fbFeed.facebookPageFeed.pagePlaceholder': 'Chọn Page',
    'fbFeed.facebookPageFeed.pagePlaceholderNoAccount': 'Chọn tài khoản trước',
    'fbFeed.facebookPageFeed.resyncPages': 'Đồng bộ lại danh sách Page',
    'fbFeed.facebookPageFeed.resyncPagesSuccess': 'Đã đồng bộ danh sách Page',
    'fbFeed.facebookPageFeed.resyncPagesFailed': 'Đồng bộ danh sách Page thất bại',
    'fbFeed.facebookPageFeed.sync': 'Đồng bộ',
    'fbFeed.facebookPageFeed.searchLabel': 'Tìm kiếm',
    'fbFeed.facebookPageFeed.searchPlaceholder': 'Tìm theo nội dung, tên Page',
    'fbFeed.facebookPageFeed.filter': 'Lọc',
    'fbFeed.facebookPageFeed.reset': 'Đặt lại',
    'fbFeed.facebookPageFeed.selectAccountError': 'Vui lòng chọn tài khoản Facebook.',
    'fbFeed.facebookPageFeed.selectPageError': 'Vui lòng chọn Page cần đồng bộ.',
    'fbFeed.facebookPageFeed.syncDone':
      'Đồng bộ xong: lấy về {fetched} bài, cập nhật {upserted} bài.',
    'fbFeed.facebookPageFeed.syncFailed': 'Đồng bộ thất bại.',

    // FacebookPageFeed — PagePosts.js
    'fbFeed.pagePosts.title': 'Bài viết của Page: {pageName}',
    'fbFeed.pagePosts.backToPages': 'Quay lại danh sách Page',
    'fbFeed.pagePosts.syncLatest': 'Đồng bộ mới nhất',
    'fbFeed.pagePosts.accountPrefix': 'Tài khoản {accountName} · ',
    'fbFeed.pagePosts.subtitle': 'Toàn bộ bài viết Page này đã đăng, đồng bộ từ Facebook.',
    'fbFeed.pagePosts.searchLabel': 'Tìm kiếm',
    'fbFeed.pagePosts.searchPlaceholder': 'Tìm theo nội dung',
    'fbFeed.pagePosts.filter': 'Lọc',
    'fbFeed.pagePosts.syncDone': 'Đồng bộ xong: lấy về {fetched} bài, cập nhật {upserted} bài.',
    'fbFeed.pagePosts.syncFailed': 'Đồng bộ thất bại.',

    // FacebookPageFeed — components/Table.js
    'fbFeed.table.colImage': 'Ảnh',
    'fbFeed.table.colContent': 'Nội dung',
    'fbFeed.table.colType': 'Loại',
    'fbFeed.table.colEngagement': 'Tương tác',
    'fbFeed.table.colPostedAt': 'Đăng lúc',
    'fbFeed.table.colAction': 'Thao tác',
    'fbFeed.table.viewOnFacebook': 'Xem trên Facebook',
    'fbFeed.table.copyLink': 'Sao chép link',
    'fbFeed.table.removeFromList': 'Xoá khỏi danh sách',
    'fbFeed.table.deleteTitle': 'Xoá khỏi danh sách?',
    'fbFeed.table.deleteDesc':
      'Chỉ xoá bản ghi đã đồng bộ khỏi hệ thống. Bài viết trên Facebook KHÔNG bị ảnh hưởng.',
    'fbFeed.table.delete': 'Xoá',
    'fbFeed.table.deleteSuccess': 'Đã xoá khỏi danh sách.',
    'fbFeed.table.deleteFailed': 'Xoá thất bại.',
    'fbFeed.table.emptyTitle': 'Chưa có bài viết nào',
    'fbFeed.table.emptyDesc': 'Chọn tài khoản & Page rồi bấm Đồng bộ để lấy bài viết của Page',
  },
  en: {
    // FacebookAccount — FacebookAcount.js
    'fbAcc.facebookAccount.title': 'Facebook accounts',
    'fbAcc.facebookAccount.add': 'Add',
    'fbAcc.facebookAccount.searchLabel': 'Search accounts',
    'fbAcc.facebookAccount.search': 'Search',
    'fbAcc.facebookAccount.reset': 'Reset',

    // FacebookAccount — PageList.js
    'fbAcc.pageList.title': 'Pages',
    'fbAcc.pageList.titleManagedBy': 'Pages managed by {name}',
    'fbAcc.pageList.backToAccounts': 'Back to accounts',
    'fbAcc.pageList.subtitle': 'Pick a Page to view the posts it has published.',
    'fbAcc.pageList.loading': 'Loading Pages…',
    'fbAcc.pageList.loadFailed': 'Could not load Pages',
    'fbAcc.pageList.loadFailedHint': 'The token may have expired. Please log in to Facebook again.',
    'fbAcc.pageList.emptyTitle': 'No Pages',
    'fbAcc.pageList.emptyDesc': 'This account is not an admin of any Page.',
    'fbAcc.pageList.total': '{count} Pages in total',
    'fbAcc.pageList.viewPosts': 'View posts',
    'fbAcc.pageList.resync': 'Re-sync',
    'fbAcc.pageList.resyncing': 'Syncing…',
    'fbAcc.pageList.resyncSuccess': 'Page list synced',
    'fbAcc.pageList.resyncFailed': 'Sync failed',
    'fbAcc.pageList.syncedAt': 'Synced at {time}',
    'fbAcc.pageList.neverSynced': 'Not synced yet',

    // FacebookAccount — components/Table.js
    'fbAcc.table.colName': 'Account name',
    'fbAcc.table.colLink': 'Link',
    'fbAcc.table.colStatus': 'Status',
    'fbAcc.table.colCreatedAt': 'Created at',
    'fbAcc.table.colAction': 'Actions',
    'fbAcc.table.viewProfile': 'View profile',
    'fbAcc.table.viewPages': 'View Pages',
    'fbAcc.table.updateAccount': 'Update account',
    'fbAcc.table.refreshScope': 'Re-authorize / refresh scope',
    'fbAcc.table.deleteAccount': 'Delete account',
    'fbAcc.table.statusChanged': 'Account status updated',
    'fbAcc.table.statusChangeFailed': 'Failed to update account status',
    'fbAcc.table.deleteTitle': 'Delete Facebook account?',
    'fbAcc.table.delete': 'Delete',
    'fbAcc.table.deleteDescDefault': 'This action cannot be undone.',
    'fbAcc.table.deleteDescScheduled':
      'This account has {count} scheduled posts. Deleting it will pause them until you reconnect the same Facebook account (same user_id) — the schedule then resumes automatically. Do you still want to delete?',
    'fbAcc.table.deleteSuccess': 'Account deleted successfully',
    'fbAcc.table.emptyTitle': 'No data yet',
    'fbAcc.table.emptyDesc': 'Add your first record to get started',

    // FacebookPageFeed — FacebookPageFeed.js
    'fbFeed.facebookPageFeed.title': 'Page posts',
    'fbFeed.facebookPageFeed.subtitle':
      'Sync and review all posts published by the Pages you manage.',
    'fbFeed.facebookPageFeed.accountLabel': 'Facebook account',
    'fbFeed.facebookPageFeed.accountPlaceholder': 'Select an account',
    'fbFeed.facebookPageFeed.pageLabel': 'Page (you are admin)',
    'fbFeed.facebookPageFeed.pagePlaceholder': 'Select a Page',
    'fbFeed.facebookPageFeed.pagePlaceholderNoAccount': 'Select an account first',
    'fbFeed.facebookPageFeed.resyncPages': 'Re-sync Page list',
    'fbFeed.facebookPageFeed.resyncPagesSuccess': 'Page list synced',
    'fbFeed.facebookPageFeed.resyncPagesFailed': 'Failed to sync Page list',
    'fbFeed.facebookPageFeed.sync': 'Sync',
    'fbFeed.facebookPageFeed.searchLabel': 'Search',
    'fbFeed.facebookPageFeed.searchPlaceholder': 'Search by content or Page name',
    'fbFeed.facebookPageFeed.filter': 'Filter',
    'fbFeed.facebookPageFeed.reset': 'Reset',
    'fbFeed.facebookPageFeed.selectAccountError': 'Please select a Facebook account.',
    'fbFeed.facebookPageFeed.selectPageError': 'Please select a Page to sync.',
    'fbFeed.facebookPageFeed.syncDone':
      'Sync complete: fetched {fetched} posts, updated {upserted} posts.',
    'fbFeed.facebookPageFeed.syncFailed': 'Sync failed.',

    // FacebookPageFeed — PagePosts.js
    'fbFeed.pagePosts.title': 'Posts of Page: {pageName}',
    'fbFeed.pagePosts.backToPages': 'Back to Pages',
    'fbFeed.pagePosts.syncLatest': 'Sync latest',
    'fbFeed.pagePosts.accountPrefix': 'Account {accountName} · ',
    'fbFeed.pagePosts.subtitle': 'All posts this Page has published, synced from Facebook.',
    'fbFeed.pagePosts.searchLabel': 'Search',
    'fbFeed.pagePosts.searchPlaceholder': 'Search by content',
    'fbFeed.pagePosts.filter': 'Filter',
    'fbFeed.pagePosts.syncDone':
      'Sync complete: fetched {fetched} posts, updated {upserted} posts.',
    'fbFeed.pagePosts.syncFailed': 'Sync failed.',

    // FacebookPageFeed — components/Table.js
    'fbFeed.table.colImage': 'Image',
    'fbFeed.table.colContent': 'Content',
    'fbFeed.table.colType': 'Type',
    'fbFeed.table.colEngagement': 'Engagement',
    'fbFeed.table.colPostedAt': 'Posted at',
    'fbFeed.table.colAction': 'Actions',
    'fbFeed.table.viewOnFacebook': 'View on Facebook',
    'fbFeed.table.copyLink': 'Copy link',
    'fbFeed.table.removeFromList': 'Remove from list',
    'fbFeed.table.deleteTitle': 'Remove from list?',
    'fbFeed.table.deleteDesc':
      'This only removes the synced record from the system. The post on Facebook is NOT affected.',
    'fbFeed.table.delete': 'Delete',
    'fbFeed.table.deleteSuccess': 'Removed from list.',
    'fbFeed.table.deleteFailed': 'Delete failed.',
    'fbFeed.table.emptyTitle': 'No posts yet',
    'fbFeed.table.emptyDesc': 'Select an account & Page then click Sync to fetch the Page posts',
  },
};

export default fragment;
